import React from 'react';

const PrivacyPage: React.FC = () => (
  <div className="min-h-screen bg-white text-black py-20 px-4 flex flex-col items-center">
    <div className="max-w-3xl w-full mx-auto">
      <h1 className="text-4xl md:text-6xl font-black mb-8 text-center">Privacy Policy</h1>
      <p className="mb-6 text-lg text-gray-700 text-center">Last updated: June 2024</p>
      <div className="space-y-8 text-base md:text-lg text-gray-800">
        <section>
          <h2 className="font-bold text-xl mb-2">1. Information We Collect</h2>
          <p>We collect information you provide directly to us, such as when you fill out our contact form (name, email, phone, and message). We may also collect anonymous analytics data to improve our website.</p>
        </section>
        <section>
          <h2 className="font-bold text-xl mb-2">2. How We Use Your Information</h2>
          <p>Your information is used to respond to your inquiries, provide our services, and improve your experience on our website. We do not sell or share your personal information with third parties except as required by law.</p>
        </section>
        <section>
          <h2 className="font-bold text-xl mb-2">3. Cookies & Analytics</h2>
          <p>We may use cookies and analytics tools to understand how visitors use our site. You can disable cookies in your browser settings.</p>
        </section>
        <section>
          <h2 className="font-bold text-xl mb-2">4. Your Rights</h2>
          <p>You may request to access, update, or delete your personal information by contacting us at <a href="mailto:hello@digitaldreams.com" className="text-blue-600 underline">hello@digitaldreams.com</a>.</p>
        </section>
        <section>
          <h2 className="font-bold text-xl mb-2">5. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us at <a href="mailto:hello@digitaldreams.com" className="text-blue-600 underline">hello@digitaldreams.com</a>.</p>
        </section>
      </div>
    </div>
  </div>
);

export default PrivacyPage; 